<template>
  <q-layout view="hHh lpR fFf">
    <q-header class="header">
      <q-toolbar>
        <q-btn
          class="col-auto"
          flat
          round
          dense
          icon="arrow_back"
          color="grey"
          @click="$router.back()"
        />

        <q-space />

        <q-toolbar-title class="col-auto">
          <q-btn
            flat
            @click="$router.back()"
          >
            <img
              :src="$q.dark.isActive ? currentSite.lightLogoImageUrl : currentSite.darkLogoImageUrl"
              class="title-logo"
            >
          </q-btn>
        </q-toolbar-title>

        <q-space />

        <q-btn
          class="col-auto"
          flat
          round
          dense
          icon="close"
          color="grey"
          @click="$router.back()"
        />
      </q-toolbar>
    </q-header>
    <q-page-container>
      <q-page
        padding
        class="flex flex-center q-py-none"
      >
        <router-view />
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { Dark } from 'quasar'

export default {
  name: 'PlainLayout',
  configuration: ['currentSite'],
  created () {
    this.setThemeAndStyle()
  },
  methods: {
    setThemeAndStyle () {
      if (!this.currentSite) return

      this.$mh.setThemeColors(this.currentSite)

      this.$mh.setSiteStyles(this.currentSite.transformedStyles)

      // For Dark Mode toggle
      if (this.$consumer) {
        Dark.set(this.currentSite.consumerConfig.darkMode)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    background-color: $background
  }

  .title-logo {
    height: 40px;
    margin: 10px;
  }
</style>
